import type { IActionObject } from '../user/user.actions';

export const SET_GLOBAL_TOAST = 'SET_GLOBAL_TOAST';

interface IToast {
  isOpen: boolean;
  title: string;
  subTitle: string;
  duration?: number;
}

export const setGlobalModal = (toast: IToast): IActionObject<IToast> => ({
  type: SET_GLOBAL_TOAST,
  payload: toast
});
